// Auto generated file, do not manually modify!
// com.hotpads.capps.client.enums.appsnapshot.ApplicationSnapshotStatusType

export enum ApplicationSnapshotStatusType {
  COMPLETED = 'completed',
  INVITED = 'invited',
  PENDING = 'pending',
  WITHDRAWN = 'withdrawn',
}

export const ApplicationSnapshotStatusType_values = [
  ApplicationSnapshotStatusType.COMPLETED,
  ApplicationSnapshotStatusType.INVITED,
  ApplicationSnapshotStatusType.PENDING,
  ApplicationSnapshotStatusType.WITHDRAWN,
] as const;
